import { useSelector } from "react-redux";

import { ArrowDropDownCircleRounded } from "@mui/icons-material";
import { Box } from "@mui/material";

export function CopyDownLineItem(props) {
  const { onCopyDown, disabled: disabledProp } = props;
  const linesLoading = useSelector((state) => state.loading.linesLoading);
  const disabled = disabledProp || linesLoading;

  function handleClick() {
    if (!disabled && onCopyDown) {
      onCopyDown();
    }
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: "calc(100% - 0.4rem)",
        left: "calc(100% - 0.6rem)",
        display: "inline-block",
        cursor: disabled ? "not-allowed" : "pointer",
        zIndex: "insertLine",
        opacity: disabled ? 0.5 : 1,
      }}
      onClick={handleClick}
      title="Copy the row above to the row below"
    >
      <ArrowDropDownCircleRounded
        sx={{ fontSize: "1rem", color: disabled ? "text.disabled" : "icons" }}
        alt="copy the line above down to the line below"
      />
    </Box>
  );
}
